var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39.9889,
    height: 39.9889,
    rx: 10,
    fill: "#262626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9886 27.8905L11.7964 21.5252L13.0234 20.583L19.9886 25.9752L26.9539 20.583L28.1809 21.5252L19.9886 27.8905ZM19.9886 23.456L11.7964 17.0907L19.9886 10.7252L28.1809 17.0907L19.9886 23.456ZM19.9886 21.5407L25.7386 17.0907L19.9886 12.6407L14.2386 17.0907L19.9886 21.5407Z",
    fill: "#A1A1A1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/Step2.2e51f00c3d68ec0b50c20c403ca5d01a.svg";
export { ForwardRef as ReactComponent };